import React from "react";
import { Box, Typography } from "@mui/material";
import { EmpoweredQuoteStyles } from "../Styles";
import { getMeaning } from "../../utils/localization";

const EmpoweredQuote = () => {
  return (
    <Box sx={EmpoweredQuoteStyles.EmpoweredQuoteContainer}>
      <Box sx={[EmpoweredQuoteStyles.DividerBar, { ml: 2 }]} />

      <Typography sx={EmpoweredQuoteStyles.BelieveDescpTxtNew}>
        {getMeaning("ABTS.BELIEVEDSCP")}
      </Typography>

      <Box sx={EmpoweredQuoteStyles.DividerBar} />
    </Box>
  );
};

export default EmpoweredQuote;
